"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheShowreel() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const linksImages = [{
    src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/580b57fcd9996e24bc43c545.png?v=zcgz95uwn8q",
    srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/tik-tok-icon-3d-render-free-png.png?v=0fqk2bibsm8t",
    sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/tik-tok-icon-3d-render-free-png.png?v=kmoo23ktyhq",
    alt: "YouTube channel",
    href: "https://www.youtube.com/@OldWaterMusic"
  }, {
    src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/Linkedin-logo-on-transparent-Background-PNG-600x600-1.png?v=8ykc375ng7d",
    srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/Linkedin-logo-on-transparent-Background-PNG-600x600-1.png?v=q7dr189qinp",
    sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/Linkedin-logo-on-transparent-Background-PNG-600x600-1.png?v=6bfu5i6ullx",
    alt: "LinkedIn professional profile",
    href: "https://www.linkedin.com/in/johannes-norris-brown-6b35992b2/"
  }, {
    src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/instagram-Logo-PNG-Transparent-Background-download.png?v=6ja4g3pd0hs",
    srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/1058183-3632888953.png?v=cek41gjxodj",
    sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/1058183-3632888953.png?v=pf2hv9jhmwl",
    alt: "Instagram profile",
    href: "https://www.instagram.com/old.water.music"
  }, {
    src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/airgigs.png?v=56r03pnxnme",
    srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/airgigs.png?v=s5zcoa0hac",
    sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/airgigs.png?v=07txztdu82tk",
    alt: "AIRGigs",
    href: "https://www.airgigs.com/user/OldWaterMusic"
  }, {
    src: "https://oldwatermusic.com/wp-content/uploads/2026/10/imdb-logo-transparent-background-free-png-1.png",
    srcset: "https://oldwatermusic.com/wp-content/uploads/2026/10/imdb-logo-transparent-background-free-png-1.png",
    sizes: "https://oldwatermusic.com/wp-content/uploads/2026/10/imdb-logo-transparent-background-free-png-1.png",
    alt: "IMDB",
    href: "https://www.imdb.com/name/nm18804719/"
  }, {
    src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/tik-tok-icon-3d-render-free-png.png?v=sctqk1yvnc8",
    srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/tik-tok-icon-3d-render-free-png.png?v=hwi84imu26q-wvc-srcset",
    sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/tik-tok-icon-3d-render-free-png.png?v=sft6m4u2soo-wvc-sizes",
    alt: "TikTok",
    href: "https://www.tiktok.com/@oldwatermusic"
  }];
  const musicImages = [{
    src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/Old-Water-icon.png?v=npqn9hidxup",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684487/img/Web-Icon-light-trans.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684487/img/Web-Icon-light-trans.png",
    alt: "Linktree",
    href: "https://linktr.ee/oldwater"
  }, {
    src: "https://oldwatermusic.com/wp-content/uploads/2026/07/Composed-RED.png?v=w438qn64te",
    srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/Composed.png?v=lpsuzgaic7c",
    sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/Composed.png?v=b3ftpknh8tf",
    alt: "Composer",
    href: "https://open.spotify.com/playlist/3IruYa3zjM66RtML96zR98?si=uCed9aNFTZqsQ-GMnNcEVw"
  }, {
    src: "https://oldwatermusic.com/wp-content/uploads/2026/07/Mastered-RED.png?v=kv1g1phv3yg",
    srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/Mastered.png?v=swcsuxvxqaf",
    sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/Mastered.png?v=ktkr9aj5b1",
    alt: "Master",
    href: "https://open.spotify.com/playlist/0JczIvfvd9bB672H7KywUd?si=RiNa40cuTru0gXqmxtm40g"
  }, {
    src: "https://oldwatermusic.com/wp-content/uploads/2026/07/Mixed-RED.png?v=vg5a35899wi",
    srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/Mixed.png?v=r3qz34o2s7",
    sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/Mixed.png?v=dqf6l9ia38",
    alt: "Mixed",
    href: "https://open.spotify.com/playlist/4eI6Ao9sSWthkJsQKDjcp8?si=z0s8G1_TQi-rD1hPDfNlTg"
  }, {
    src: "https://oldwatermusic.com/wp-content/uploads/2026/07/Performed-REED.png?v=w48lxsu9az",
    srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/Performed.png?v=9stei7yr4k",
    sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/Performed.png?v=vv78adqwu2j",
    alt: "Perform",
    href: "https://open.spotify.com/playlist/4AcpwhRZzFBMCavXO5W4MX?si=u6GcPFFIRqSo3_dq3hxF0g"
  }, {
    src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/Spotify-Logo.png?v=m0d9dwica2",
    srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/Spotify-Logo.png?v=goxs4pasgig-wvc-srcset",
    sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/Spotify-Logo.png?v=2bn6qe9flvz-wvc-sizes",
    alt: "Spotify",
    href: "https://open.spotify.com/artist/21WtPN34fyR9XE4FzIQJrR?si=F3FAlp4nQTuLlDDPuCnVnw"
  }];
  const audioTracks = [{
    id: 1,
    title: "WORLD MUSIC TEXTURES SHOWREEL",
    src: "https://oldwatermusic.com/wp-content/uploads/2026/08/World-Textures-Showreel-Old-Water-Official-Audio-FINAL.mp3"
  }, {
    id: 2,
    title: "Beats & Electronic Showreel",
    src: "https://oldwatermusic.com/wp-content/uploads/2026/08/Beats-Showreel-Old-Water-Official-Audio-FINAL.mp3"
  }, {
    id: 3,
    title: "Acoustic Journeys Showreel",
    src: "https://oldwatermusic.com/wp-content/uploads/2026/08/Acoustic-Journies-Showreel-Old-Water-Official-Audio-FINAL.mp3"
  }];
  const videoUrl = "https://www.youtube.com/embed/DGnEH4tV65g?si=iDlu0u8X-tnxXbt4";
  return <section data-section-id="233250" id="the-showreel" className="text-foreground relative overflow-hidden bg-background/0 ![padding:50px_0px_50px_0px]" ref={ref}>
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px] bg-secondary/10 rounded-lg blur-[120px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 relative z-10 transition-all duration-1000 ease-out opacity-100 translate-y-0 !bg-transparent sm:px-6 lg:px-8">
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          
          {}
          <div className="space-y-8">
            
            <div className="space-y-6 text-foreground/80 font-default leading-relaxed text-base md:text-lg">
              <p className="!font-serif !text-center !font-bold !text-[38px] !h-[58px] border-[oklab(0.98480500/0.8)] !border-8 !border-none">JOHANNES NORRIS-BROWN</p>
            </div>
            
            <div className="space-y-6 text-foreground/80 font-default leading-relaxed text-base md:text-lg">
              <p className="text-secondary !font-bold !text-center ![margin:60px_0px_0px_0px]">COMPOSER • PRODUCER • SOUND DESIGNER</p>
              <p className="![margin:20px_0px_24px_0px] !font-default !font-semibold !opacity-[0.95]">Johannes, aka Øld Water, is a composer and music producer based in Dublin. He has spent over 13 years working in the music industry, the most recent 4 years specialising in Composition and Production and previously as a session musician, university lecturer and event promoter.</p>
              <p className="!font-semibold !opacity-[0.95]">His work includes soundtracks & sound design for independent film and video, mixing, mastering & production for artists from around the world including Latin America, Japan, Europe and beyond, session work, original music and video production under the name Øld Water and much more. Check out the Showreels for a taste of his work</p>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <div className="w-full lg:w-[100%] aspect-video rounded-lg overflow-hidden bg-card/60 backdrop-blur-2xl shadow-4xl ring-1 ring-white/5">
              <iframe className="w-full h-full !border-solid !border-1 !border-[rgba(141,103,38,1)]" src={videoUrl} title="SONIQ Showreel" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen loading="lazy"></iframe>
            </div>

            {}
            <div className="space-y-3 pt-2">
              {audioTracks.map((track, i) => <div key={track.id} data-index={i} className="backdrop-blur rounded-lg ring-1 ring-white/5 p-3.5 space-y-2 !bg-[rgba(48,17,75,0.41)] !border-solid !border-1 !border-[rgba(157,110,39,1)] shadow">
                  <p className="text-foreground/80 font-default uppercase tracking-wide text-xs font-semibold">
                    {track.title}
                  </p>
                  <audio controls className="w-full h-8" preload="metadata">
                    <source src={track.src} type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                </div>)}
            </div>
          </div>
        </div>

        {}
        <div className="mt-16">
          <Link to="#" className="w-full block">
            <Button variant="secondary" size="lg" className="w-full rounded-lg py-8 text-sm font-bold uppercase tracking-widest shadow-2xl shadow-secondary/20 hover:bg-primary hover:text-primary-foreground transition-all duration-500">
              View Full Portfolio
            </Button>
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-8 ![margin:20px_0px_0px_0px] md:grid-cols-2">
          <div className="rounded-lg backdrop-blur-sm border border-border/50 min-h-[200px] flex flex-col items-start justify-center overflow-hidden !opacity-[1] ![padding:0px_16px_0px_16px] bg-card/40 !h-[160px]">
            <h3 className="text-xs uppercase tracking-widest mb-4 text-center w-full !font-sans !font-bold text-primary">LINKS&nbsp;&amp; SOCIALS</h3>
            <div className="grid grid-cols-6 gap-2 w-full">
              {linksImages.map((image, i) => <div key={i} data-index={i} className="aspect-square rounded-md overflow-hidden bg-muted/20 flex items-center justify-center">
                  {image.href ? <Link to={image.href} newTab className="w-full h-full flex items-center justify-center">
                      <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} className="w-[80%] h-[80%] object-cover hover:scale-110 transition-transform duration-500" loading="lazy" />
                    </Link> : <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} className="w-[80%] h-[80%] object-cover hover:scale-110 transition-transform duration-500" loading="lazy" />}
                </div>)}
            </div>
          </div>
          <div className="backdrop-blur-sm border border-border/50 min-h-[200px] flex flex-col items-center justify-center overflow-hidden ![padding:0px_16px_0px_16px] rounded-lg bg-card/40 !h-[160px]">
            <h3 className="text-xs uppercase tracking-widest mb-4 text-center w-full !font-sans !font-bold text-primary">Music & Playlists</h3>
            <div className="grid grid-cols-6 gap-2 w-full">
              {musicImages.map((image, i) => <div key={i} data-index={i} className="aspect-square rounded-md overflow-hidden bg-muted/20 flex items-center justify-center">
                  <Link to={image.href} newTab className="w-full h-full flex items-center justify-center">
                    <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} className="w-[80%] h-[80%] object-cover hover:scale-110 transition-transform duration-500" loading="lazy" />
                  </Link>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}